
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subcategories/[slug]",
      function () {
        return require("private-next-pages/subcategories/[slug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subcategories/[slug]"])
      });
    }
  